<div class="container">

  <app-header-dialog [iconName]="'monetization_on'">
    Usuários
  </app-header-dialog>

  <div class='content'>

    <mat-card>
      <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro' autocomplete="off">
    </mat-card>

    <!-- TABLE -->
    <mat-table [dataSource]="dataSource" matSort matSortActive="name"
      style='height:420px; overflow:auto; margin: 10px 0 0 0;'>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.name }} </mat-cell>
      </ng-container>

      <!-- Selected Column -->
      <ng-container matColumnDef="selected">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-checkbox color='primary' [(ngModel)]="element.selected"></mat-checkbox>
        </mat-cell>
      </ng-container>

      <!-- Header -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <!-- Row -->
      <mat-row *matRowDef="let row; columns: displayedColumns;">
      </mat-row>

    </mat-table>
    <!-- END TABLE -->

  </div>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

    <button mat-raised-button (click)="matDialogRef.close([ 'ok', dataSource.data ])">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

  </div>

</div>